import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech1_764e3b9591.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_Diya_Gurung_d10a2997f3.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_Mingma_30855c80e9.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_OJT_Image_74fff7e99f.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_Sudip_Subba_125d7a850a.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_SOVA_12566616f0.webp";

const Img1 = "https://cdn.msu.edu.in/art_1_74e627663e.webp";
const Img2 = "https://cdn.msu.edu.in/Physiotherapy_491bd76002.webp";
const Img3 = "https://cdn.msu.edu.in/Physiotherapy_3_2081e88313.webp";
const Img4 = "https://cdn.msu.edu.in/Physiotherapy_5_452d7e359e.webp";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const bpData = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Bachelor of Physiotherapy", url: "" }
        ],
        bannerImg: "https://img.youtube.com/vi/_V9KjiMUfBM/hqdefault.jpg",
        title: "Bachelor of Physiotherapy",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: EMVERSITY
        },
        duration: "5 Year Undergraduate Degree Programme",
        description:
            "Learn about Human Physiology, Pathology and Microbiology, General Surgery, Clinical Rotation and more in the medical sector.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement Assistance"
            }
        ],

        buttons: {
            download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: "https://img.youtube.com/vi/_V9KjiMUfBM/hqdefault.jpg",
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/_V9KjiMUfBM"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",
        title: "Programme for a Career in Physiotherapy",
        description: [
            "The Bachelor of Physiotherapy is a five-year undergraduate programme that prepares students to become qualified physiotherapy professionals skilled in assessing, diagnosing and treating movement disorders, musculoskeletal conditions, neurological impairments and cardiopulmonary dysfunction. The programme integrates evidence-based clinical reasoning with hands-on therapeutic techniques, equipping graduates to restore mobility, manage pain and improve quality of life for patients across all age groups.",
            "This program at Medhavi Skills University is delivered through a unique partnership model: MSU provides the academic framework, degree conferral, examinations and campus infrastructure while Emversity delivers the industry-skilling component, including AR/VR simulation-based training, employer-co-designed curriculum modules, structured clinical internships and placement assistance through its network of 500+ healthcare employer partners."
        ],
        stats: [
            { value: "Up to 70%", label: "Practical Curriculum" },
            { value: "Paid", label: "On-the-job learning" },
            { value: "100%", label: "Placement Assistance" }
        ],
        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],
        journeyTitle: "Your 5-Year Journey",
        journey: [
            {
                phase: "YEAR 1",
                title: "Biomedical Foundations",
                description: "Build a strong scientific base with core concepts in human anatomy, physiology and movement science."
            },
            {
                phase: "YEAR 2",
                title: "Clinical Sciences & Therapeutic Foundations",
                description: "Build clinical competence through pathology, electrotherapy and structured patient assessment techniques."
            },
            {
                phase: "YEAR 3",
                title: "Advanced Physiotherapy & Specialisation",
                description: "Advance into specialised areas including orthopaedics, neurology, sports rehab and assistive technologies."
            },
            {
                phase: "YEAR 4",
                title: "Clinical Practice & Professional Readiness",
                description: "Refine hands-on expertise with advanced manual therapy, critical care physiotherapy and real-world clinical exposure."
            },
            {
                phase: "YEAR 5 (FINAL PHASE)",
                title: "On-the-Job Learning",
                description: "Paid full-time experience in independent case handling and industry-ready practice."
            },
            {
                phase: "GRADUATE",
                title: "Bachelor of Physiotherapy",
                description: "Industry-ready physiotherapy professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",
        title: {
            first: "Comprehensive",
            highlight: "Undergraduate Physiotherapy Education"
        },
        description:
            "We offer a UGC-approved, 5-year full-time undergraduate degree of Bachelor of Physiotherapy at Medhavi Skills University, Sikkim. It is an industry-aligned healthcare degree designed to build strong therapeutic skills and prepare students for diverse roles.",
        learningBox: {
            title: "Key Areas of Learning",
            points: [
                "Human Anatomy",
                "Pathology & Microbiology",
                "Orthopedics",
                "General Surgery",
                "Cardiothoracic Diseases and Surgeries",
                "Neurological Physiotherapy"
            ]
        },
        image: "https://cdn.msu.edu.in/Physiotherapy_2_56ec4bd276.webp"
    },

    whyEMT: {
        tag: "WHY PHYSIOTHERAPY. WHY NOW.",
        title: "Meeting the Rising Demand for Rehabilitation Professionals in India",
        description:
            "This programme equips students with practical skills and clinical expertise needed across hospitals, sports rehab and therapeutic care settings.",
        stats: [
            {
                value: "1.2 Million",
                text: "Physiotherapy professionals will be needed in India by 2030, creating an extraordinary career opportunity for qualified graduates across hospitals, clinics and rehabilitation centres.",
            },
            {
                value: "70%",
                text: "Of rehabilitation clinics report high demand for skilled physiotherapists, highlighting a critical talent shortage and long-term career security for qualified professionals in this field.",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Emversity, Delivered at MSU Campus",
        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",
        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job-Learning embedded curriculum for practical learning.",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships.",
            },
            {
                number: "03",
                text: "Well-equipped labs, advanced training setups and hands-on field training.",
            },
        ],
        pointerTitle: "Highlights from The Programme:",
        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-Job Learning (OJL)",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned physiotherapy professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives"
        ],
        image: "https://cdn.msu.edu.in/advantages_b072c172b5.webp",
    },

    CTA: {
        title: "Begin Your Journey in Movement & Recovery Science with Emversity's",
        highlights: "Bachelor of Physiotherapy",
        url: "#",
        btnName: "Apply Now"
    },

    onJobtrainningData: {
        tag: "ON-THE-JOB LEARNING",
        title: "Practical Industry Exposure",
        description: "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
        images: [
            { id: 1, src: OJLImg1, alt: "Pranita Pradhan at CRH Manipal, Gangtok" },
            { id: 2, src: OJLImg2, alt: "Diya Gurung at Kasturi Diagnostic, Namchi" },
            { id: 3, src: OJLImg3, alt: "Mingma Topden Bhutia at Kasturi Diagnostic, Namchi" },
            { id: 4, src: OJLImg4, alt: "Sonika Chettri at District Hospital, Singtam" },
            { id: 5, src: OJLImg5, alt: "Sudip Subba at STNM, Gangtok" },
            { id: 6, src: OJLImg6, alt: "Sova Pradhan at Ruchi Diagnostic, Gangtok" }
        ]
    },

    addtionSkill: {
        courseSections: {
            AdditionalSkills: {
                tag: "BONUS CERTIFICATIONS",
                title: "Additional Skills Certifications",
                description: "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like Basic Life Support (BLS)/ACLS, Manual Therapy Courses (MFR, MET, Maitland basics), Kinesio Taping, Dry Needling, Sports Rehabilitation Modules and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",
                image: {
                    url: "https://cdn.msu.edu.in/small_DSC_00675_1_5308732449.jpg",
                    alternativeText: "Skill Certification"
                },
                items: [
                    { id: 1, text: "Basic Life Support (BLS) / ACLS Certification", icon: Icon1 },
                    { id: 2, text: "Manual Therapy, Kinesio Taping & Dry Needling Modules", icon: Icon2 },
                    { id: 3, text: "Sports Rehabilitation & Nationally Recognised Credentials", icon: Icon1 }
                ],
                button: { text: "Apply Now", link: "/apply" }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description: "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities.",
        images: [
            { id: 1, src: Img1, size: "large", alt: "Classrooms" },
            { id: 2, src: Img2, size: "large", alt: "Physiotherapy Units" },
            { id: 3, src: Img3, size: "small", alt: "Physiotherapy Equipments" },
            { id: 4, src: Img4, size: "small", alt: "Emergency Units" },
            { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
        ],
    },

    studentStoriesData: {
        title: "Medhavians Speak",
        subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Who Can Apply?",
        description: "12th Pass (10+2) with Physics, Chemistry and Biology/Mathematics as core subjects.",
        button: { text: "Apply Now", url: "" },
        items: [
            {
                title: "12th Pass - Science Stream",
                text: "Candidates who have passed 10+2 with Physics, Chemistry and Biology/Mathematics as core subjects are eligible to apply for the Bachelor of Physiotherapy programme.",
            },
        ],
    },

    careerProspects: {
        tag: "CAREER PROSPECTS",
        heading: "Career Prospects",
        description: "Access a wide range of career opportunities in physiotherapy, driven by high demand for skilled physiotherapists.",
        roles: [
            "Clinical Physiotherapist",
            "Sports Physiotherapist",
            "Orthopaedic Physiotherapist",
            "Neurological Rehabilitation Specialist",
            "Geriatric Physiotherapist",
            "Pediatric Physiotherapist",
            "Cardiopulmonary Physiotherapist",
            "Rehabilitation Consultant",
            "Physiotherapy Lecturer",
            "Research Assistant",
            "Occupational Health Physiotherapist",
            "Ergonomics and Workplace Wellness Specialist",
            "Home Care Physiotherapist",
            "Rehabilitation Trainer",
            "International Physiotherapy Practitioner"
        ]
    },

    curriculumStructure: {
        label: "WHAT YOU WILL LEARN",
        heading: "Curriculum Structure",
        description: "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness and broad career opportunities across disciplines.",
        semesters: [
            {
                name: "Year 1",
                title: "Building Foundations in Human Movement and Rehabilitation Sciences",
                description: "The first year establishes a strong foundation in the biological, behavioural, and healthcare sciences that underpin physiotherapy practice. Students develop a comprehensive understanding of human anatomy, physiology, and biochemistry while gaining exposure to exercise modalities, electrotherapy principles, and healthcare systems. The curriculum also introduces psychological and sociological perspectives, communication skills, digital literacy, and clinical environments, enabling learners to build the knowledge, skills, and professional awareness required for future clinical training.",
                subjects: [
                    { name: "Human Anatomy (HA)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Human Physiology (HP)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Biochemistry (BC)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Fundamentals of Exercise Modalities (FoEM)", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Fundamentals of Electro Physical Agents (FoEA)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Psychology & Sociology (PS)", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Fundamentals of Healthcare Delivery System in India (FoHS)", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "English (EG)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Information Technology (IT)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Clinic Orientation (COr)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" }
                ]
            },
            {
                name: "Year 2",
                title: "Strengthening Clinical Knowledge and Therapeutic Practice",
                description: "The second year builds upon foundational sciences by introducing students to core clinical subjects and therapeutic interventions essential to physiotherapy practice. Through the study of pathology, pharmacology, biomechanics, exercise therapy, and electrotherapy, learners develop a deeper understanding of disease processes, movement mechanics, and rehabilitation techniques. The curriculum also incorporates public health, emergency care, and clinical observation experiences, enabling students to connect theoretical knowledge with patient care while strengthening their clinical reasoning and professional competencies.",
                subjects: [
                    { name: "Pathology & Microbiology (PM)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Pharmacology (PC)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Public Health & Health Promotion (PH)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Emergency Care and Life Support Skills (ECLS)", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Exercise Therapy (ExT)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Electrotherapy (ET)", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Biomechanics & Kinesiology (BK)", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "Yoga and Systems of Medicine (YoG)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Clinical Observation (COb)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" }
                ]
            },
            {
                name: "Year 3",
                title: "Advancing Clinical Rehabilitation and Evidence-Based Practice",
                description: "The third year focuses on the assessment and management of complex medical, surgical, orthopedic, and pediatric conditions encountered in physiotherapy practice. Students develop advanced clinical reasoning skills through the study of physical and functional diagnosis, therapeutic interventions, and rehabilitation strategies across diverse patient populations. The curriculum also emphasizes research methodology, biostatistics, and evidence-based practice, enabling learners to make informed clinical decisions while strengthening their ability to deliver effective, patient-centred care in real-world healthcare settings.",
                subjects: [
                    { name: "General Medicine and Pediatrics (GMP)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "General Surgery (GS)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Orthopedics (OR)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Physiotherapy in Adult and Pediatric Medical and Surgical Conditions  (PTMS)", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Physiotherapy in Adult and Pediatric Orthopedics Conditions (PTO)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Physical & Functional Diagnosis & Prescription (PFDP)", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Research Methodology, Biostatistics and Evidence Based Practice (RMB)", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "Clinical Education (CEd)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
                ]
            },
            {
                name: "Year 4",
                title: "Mastering Specialized Rehabilitation and Professional Practice",
                description: "The final academic year focuses on specialized areas of physiotherapy, preparing students to manage neurological, cardiothoracic, sports, and community-based rehabilitation needs across diverse patient populations. Through advanced clinical learning, students develop expertise in assessment, treatment planning, and evidence-based intervention strategies for complex health conditions. The curriculum also introduces healthcare ethics, legal considerations, management principles, and research-oriented learning, enabling learners to refine their professional judgment and leadership capabilities while preparing for clinical practice and lifelong learning.",
                subjects: [
                    { name: "Neurology, Psychiatry and Neurosurgery (NPNS)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Physiotherapy in Adult and Pediatric Neurological and Neurosurgical Conditions (PTN)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Cardiothoracic Diseases and Surgeries (CTD)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Physiotherapy in Adult and Pediatric Cardiothoracic and Surgical Conditions (PTCT)", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Sports Physiotherapy & Exercise Prescription (PTS)", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Ethics, Medico Legal Aspects, Management Administration (PTLM)", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Community Physiotherapy & Rehabilitation (CPTR)", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "Project Work Orientation (PW)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Clinical Rotation (CR)", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" }
                ]
            },
            {
                name: "Year 5",
                title: "Integrating Clinical Expertise Across Diverse Healthcare Settings",
                description: "The internship phase provides students with comprehensive exposure to a wide range of physiotherapy specialties, enabling them to apply their knowledge and clinical skills in real-world healthcare environments. Through rotational postings across medical, surgical, neurological, orthopedic, cardiothoracic, pediatric, sports, and community care settings, students gain hands-on experience in patient assessment, rehabilitation planning, interdisciplinary collaboration, and evidence-based practice. This immersive training helps strengthen professional competence, clinical confidence, and readiness for independent physiotherapy practice.",
                subjects: [
                    { name: "Musculoskeletal / Orthopaedic Physiotherapy", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Neurological Physiotherapy", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Community Physiotherapy / Rural Posting", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Cardiology ICU / NICU", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Pulmonology / TB Hospital / Medicine", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Sports Physiotherapy", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Obstetrics and Gynaecological Physiotherapy", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "Pediatric", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Surgery / Oncology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Burns and Plastic Surgery", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" }
                ]
            },
            {
                name: "Value Addition",
                title: "Value-Added Learning Opportunities",
                description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                keySubjectsLabel: "Key Features",
                subjects: [
                    { name: "Skill certifications", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "One workshop per semester", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "One industry visit per semester", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" }
                ],
                learningOutcomes: [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]
    },

    faq: {
        id: 104,
        title: "Bachelor of Physiotherapy",
        FAQ: [
            {
                id: 1,
                Question: "What is the university's role and what is Emversity's role?",
                Answer: "MSU manages all academic matters — admissions, examinations, marksheets, transcripts and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance and the Cambridge English program. Emversity does not collect fees, conduct exams or award degrees."
            },
            {
                id: 2,
                Question: "Is placement or internship stipend guaranteed?",
                Answer: "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution."
            },
            {
                id: 3,
                Question: "Is this program recognised and is it full-time?",
                Answer: "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university."
            },
            {
                id: 4,
                Question: "How do I apply?",
                Answer: "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details and application deadlines, please contact the MSU admissions office directly."
            },
            {
                id: 5,
                Question: "What is the Head Start Programme?",
                Answer: "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships."
            },
            {
                id: 6,
                Question: "Is this programme NCAHP aligned?",
                Answer: "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus."
            }
        ]
    },

    coursePrice: { price: "₹10,00,000" }
};